<template>
  <div class="card">
    <div
      class="card-body"
    >
      <p class="card-text mb-3">
        Photo Processing Report
      </p>
      <p>
        This is a time consuming report, please be patient. <button
          class="btn btn-outline-primary"
          @click.prevent="search"
          :disabled="loading"
        >
          Generate report
        </button>
        <span v-if="loading">in progress, loaded logins: {{ loadedLogins }}</span>
      </p>
      <table
        v-if="imageProcessingReport"
        class="table table-striped table-bordered with-header-border"
      >
        <thead
          style="position: sticky;top:65px;background:white"
        >
          <tr>
            <th>
              Login
            </th>
            <th>
              Properties
            </th>
            <th>
              Properties with no photos
            </th>
            <th>
              Properties with all photos invalid
            </th>
            <th>
              Properties with some/all photos invalid
            </th>
            <th>
              Detailed report
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="entry in imageProcessingReport"
            :key="entry.login"
            :class="entry.propertiesWithAllPhotosInvalid > 0 ? 'table-danger' : (entry.propertiesWithInvalidPhotos > 0 || entry.propertiesWithNoPhotos > 0) ? 'table-warning' : ''"
          >
            <td>
              {{ entry.login }}
            </td>
            <td>
              {{ entry.properties }}
            </td>
            <td>
              {{ entry.propertiesWithNoPhotos }}
            </td>
            <td>
              {{ entry.propertiesWithAllPhotosInvalid }}
            </td>
            <td>
              {{ entry.propertiesWithInvalidPhotos }}
            </td>
            <td>
              <a
                @click.prevent="loadImageReport( entry.login );imageReportLogin = entry.login;detailedImageReportMode = true"
                href=""
              >
                see detailed report
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      :class="`modal fade px-0 ${detailedImageReportMode ? 'show d-block' : 'd-none'}`"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div
          class="modal-content"
          style="min-width: 900px;"
        >
          <div class="modal-header">
            <h5 class="modal-title">
              Detailed image report for {{ imageReportLogin }} <span v-if="loadingImageReport">loading...</span>
            </h5>
            <button
              type="button"
              class="close"
              @click="detailedImageReportMode = false;"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body container-fluid text-center">
            <table
              v-if="imageReport"
              class="table table-striped"
            >
              <thead
                style="position: sticky;top:0;background:white"
              >
                <th>Property</th>
                <th>Agent Ref</th>
                <th>Images</th>
                <th>Invalid</th>
                <th>Processed</th>
                <th>Processed ok</th>
                <th>Pending table sync</th>
              </thead>
              <tbody>
                <tr
                  v-for="(propertyImageReport, idx) in imageReport"
                  :key="idx"
                  :class="(propertyImageReport.total > 0 && propertyImageReport.total == propertyImageReport.invalid) ? 'table-danger' : (propertyImageReport.total == 0 || propertyImageReport.invalid > 0 || propertyImageReport.total > propertyImageReport.ok) ? 'table-warning' : ''"
                >
                  <td>{{ propertyImageReport.propertyId }}</td>
                  <td>{{ propertyImageReport.agentRef }}</td>
                  <td>{{ propertyImageReport.total }}</td>
                  <td>{{ propertyImageReport.invalid }}</td>
                  <td>{{ propertyImageReport.processed }}</td>
                  <td>{{ propertyImageReport.ok }}</td>
                  <td>{{ propertyImageReport.pendingTableSync }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import adminapi from '../../../http';
import notify from '../../../notifications';

export default {
    data() {
        return {
            loading: false,
            loadingImageReport: false,
            loadedLogins: 0,
            imageProcessingReport: null,
            detailedImageReportMode: false,
            imageReport: null,
            imageReportLogin: null
        };
    },
    methods: {
        async loadImageReport( login ) {
            this.imageReport = null;
            this.loadingImageReport = true;

            let url = '/photo-report-detailed/' + login;

            const response = await adminapi.get( url );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    text: 'Something went wrong',
                    title: 'Failed to load image report'
                } );
                this.loadingImageReport = false;
                return;
            }

            var imageReport = await response.json();

            // sorting - first invalid, then warning, then ok
            function compareImageReport( first, second ) {
                let isFirstoffline = ( first.total > 0 && first.total == first.invalid );
                let isSecondoffline = ( second.total > 0 && second.total == second.invalid );

                if ( isFirstoffline && !isSecondoffline ) {
                    return -1;
                }

                if ( !isFirstoffline && isSecondoffline ) {
                    return 1;
                }

                let isFirstWarning = ( first.total == 0 || first.invalid > 0 || first.total > first.ok );
                let isSecondWarning = ( second.total == 0 || second.invalid > 0 || second.total > second.ok );

                if ( isFirstWarning && !isSecondWarning ) {
                    return -1;
                }

                if ( !isFirstWarning && isSecondWarning ) {
                    return 1;
                }

                return 0;
            }

            imageReport = imageReport || [];

            imageReport.sort( compareImageReport );

            this.loadingImageReport = false;
            this.imageReport = imageReport;
        },
        async search() {
            this.loading = true;
            this.loadedLogins = 0;
            this.imageProcessingReport = [];
            let continueSearch = true;
            let take = 50;
            let skip = 0;
            let allEntries = [];
            while ( continueSearch ) {
                var url = `/image-processing-report?take=${ take }&skip=${ skip }`;

                const response = await adminapi.get( url );

                if ( response.status !== 200 ) {
                    notify( {
                        type: 'error',
                        text: 'Something went wrong',
                        title: 'Failed to load image processing report'
                    } );
                    this.loading = false;
                    return;
                }

                let entries = await response.json();

                if ( !entries || entries.length < take ) {
                    continueSearch = false;
                    break;
                }

                allEntries = allEntries.concat( entries );
                this.loadedLogins += entries.length;
                skip += take;
            }

            allEntries.sort( ( firstLogin, secondLogin ) => {
                // first logins by number of all properties with photos invalid
                // then logins by number of properties with some invalid photos
                // then logins with no photos

                if ( firstLogin.propertiesWithAllPhotosInvalid != secondLogin.propertiesWithAllPhotosInvalid ) {
                    return secondLogin.propertiesWithAllPhotosInvalid - firstLogin.propertiesWithAllPhotosInvalid;
                }

                if ( firstLogin.propertiesWithNoPhotos != secondLogin.propertiesWithNoPhotos ) {
                    return secondLogin.propertiesWithNoPhotos - firstLogin.propertiesWithNoPhotos;
                }

                if ( firstLogin.propertiesWithInvalidPhotos != secondLogin.propertiesWithInvalidPhotos ) {
                    return secondLogin.propertiesWithInvalidPhotos - firstLogin.propertiesWithInvalidPhotos;
                }

                return 0;
            } );

            this.imageProcessingReport = allEntries;

            this.loading = false;
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/xmlimport/imageprocessingreport.vue